import { render, staticRenderFns } from "./preview1.vue?vue&type=template&id=15dfc97e&scoped=true&"
import script from "./preview1.vue?vue&type=script&lang=js&"
export * from "./preview1.vue?vue&type=script&lang=js&"
import style0 from "./preview1.vue?vue&type=style&index=0&id=15dfc97e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfc97e",
  null
  
)

export default component.exports